export interface Review {
	avatar: string;
	avatar_color: string;
	person: string;
	rate: number;
	date: string;
	description: string;
}

export const allReviews: Review[] = [
	{
		avatar: 'A',
		avatar_color: '#A87B75',
		person: 'Alicja',
		rate: 5,
		date: 'Marzec, 2026',
		description: 'Merytoryczne prowadzenie małej grupy przez treningi, stały kontakt i odpowiedzi na wszystkie pytania. Amelia ma ogromną wiedzę o tym jak prowadzić kobiety w treningu. Bardzo pomogła mi z bólami — już po kilku tygodniach poczułam realną różnicę. Serdecznie polecam!',
	},
	{
		avatar: 'P',
		avatar_color: '#A87B75',
		person: 'Pati',
		rate: 5,
		date: 'Marzec, 2026',
		description: 'Amelia jest bardzo dobrą trenerką, na którą w trakcie współpracy zawsze można było liczyć 🥰 Odpowiadała na zadane pytania, okazywała wsparcie nie tylko merytoryczne, ale również psychiczne. Polecam serdecznie!',
	},
	{
		avatar: 'M',
		avatar_color: '#f97316',
		person: 'Monika Poręba',
		rate: 5,
		date: 'Maj, 2025',
		description: 'Polecam 😊',
	},
	{
		avatar: 'L',
		avatar_color: '#8b5cf6',
		person: 'Laura Janda',
		rate: 5,
		date: 'Marzec, 2025',
		description: 'Polecam współpracę z Amelią — jest bardzo profesjonalna i widać, że zna się na rzeczy. Treningi są zawsze ciekawe, a sama Amelia to bardzo dobra motywatorka. Pomaga, poprawia błędy i tłumaczy każde ćwiczenie, żebym rozumiała co i dlaczego robię. Na pewno będę kontynuować!',
	},
	{
		avatar: 'P',
		avatar_color: '#A87B75',
		person: 'Patryk Arendt',
		rate: 5,
		date: 'Marzec, 2024',
		description: 'Jestem niezmiernie zadowolony z współpracy z Panią Amelią — jej zaangażowanie, profesjonalizm i empatia przekroczyły moje oczekiwania. Posiada dogłębną wiedzę na temat ćwiczeń i planowania treningów. Całkowicie polecam Panią Amelię jako profesjonalistkę!',
	},
	{
		avatar: 'K',
		avatar_color: '#6366f1',
		person: 'Krystian Janas',
		rate: 5,
		date: 'Marzec, 2024',
		description: 'Pracuję z Amelią jako trenerem personalnym od pewnego czasu i jestem niezwykle zadowolony z efektów naszej współpracy. Amelia dostarcza ogromną dawkę motywacji i zawsze trafne wskazówki. Punktualność bez zarzutu — zawsze gotowa na czas. Z całą pewnością polecam Amelię każdemu!',
	},
	{
		avatar: 'M',
		avatar_color: '#0d9488',
		person: 'Miłosz',
		rate: 5,
		date: 'Styczeń, 2024',
		description: 'Polecam serdecznie. Amelia wykazuje ogromne zaangażowanie w pracy z klientami i potrafi motywować do osiągania celów treningowych. Jej profesjonalizm i wiedza na temat treningu oraz zdrowego stylu życia są imponujące. Każdy trening jest przemyślany i dostosowany do moich potrzeb.',
	},
	{
		avatar: 'K',
		avatar_color: '#f59e0b',
		person: 'Katarzyna',
		rate: 5,
		date: 'Luty, 2024',
		description: 'Polecam współpracę z Amelią z całego serduszka 😊 Widać, że to co robi to jej pasja. Do tego jest bardzo sympatyczną osobą. Nasza współpraca spełnia moje oczekiwania co do zmian w moim zdrowiu, samopoczuciu i sylwetce ❤️',
	},
	{
		avatar: 'A',
		avatar_color: '#f97316',
		person: 'Aleksandra Bębnik',
		rate: 5,
		date: 'Grudzień, 2023',
		description: 'Właściwy człowiek na właściwym miejscu — współpraca z Amelką to czysta przyjemność 😊 Amelka jest bardzo ambitną osobą, znającą się na tym co robi. Bardzo szczegółowa wiedza w prowadzeniu treningu, przykłada dużą uwagę do poprawności ćwiczeń. Polecam z całego serca!',
	},
	{
		avatar: 'F',
		avatar_color: '#6366f1',
		person: 'Filip Wolski',
		rate: 5,
		date: 'Listopad, 2023',
		description: 'Polecam treningi z Amelią. Odpowiednia osoba na odpowiednim miejscu — potrafi bardzo dobrze zmotywować. Już po kilku treningach zacząłem dostrzegać efekty :) Cel, który sobie wyznaczyłem, na pewno osiągnę szybciej niż zakładałem dzięki regularnym treningom i wsparciu Amelii!',
	},
	{
		avatar: 'K',
		avatar_color: '#0ea5e9',
		person: 'Katarzyna Krzyżak',
		rate: 5,
		date: 'Październik, 2023',
		description: 'Serdecznie polecam treningi z Amelią! Świetne podejście — od początku miałam problem z pewnością siebie, a Amelia sprawia, że czuję się doskonale. Wiem, że wszystkie ćwiczenia wykonuję bezpiecznie i poprawnie. Amelia dba o każdy szczegół i naprawdę jej zależy na postępach podopiecznych.',
	},
	{
		avatar: 'N',
		avatar_color: '#ec4899',
		person: 'Natalia Cozac',
		rate: 5,
		date: 'Wrzesień, 2023',
		description: 'Amelia jest odpowiedzialną osobą — idealnie dopasowała do mnie plan treningowy 😃 Jest empatyczna i szczerze mogę ją polecić! 😇',
	},
	{
		avatar: 'P',
		avatar_color: '#64748b',
		person: 'Pleśniak',
		rate: 5,
		date: 'Sierpień, 2023',
		description: 'Wykształcony trener personalny. Profesjonalne podejście do każdej osoby. Treningi ułożone indywidualnie w zależności od preferencji i celu. Regularne sprawdzanie efektów. Polecam!!!!',
	},
	{
		avatar: 'K',
		avatar_color: '#A87B75',
		person: 'Karolina Czerkies',
		rate: 5,
		date: 'Lipiec, 2023',
		description: 'Bardzo polecam Amelię! Super osoba! Wiele mnie nauczyła. Jest bardzo pozytywną i sympatyczną osobą 🥰',
	},
	{
		avatar: 'D',
		avatar_color: '#a855f7',
		person: 'Dominika Krupka',
		rate: 5,
		date: 'Czerwiec, 2023',
		description: 'Bardzo sympatyczna osoba, z ogromną wiedzą. Współpraca z nią to czysta przyjemność. Polecam każdemu!',
	},
	{
		avatar: 'P',
		avatar_color: '#A87B75',
		person: 'Paula Jedziniak',
		rate: 5,
		date: 'Kwiecień, 2023',
		description: 'Świetna atmosfera, trening dobrany do możliwości i umiejętności ❤️ Gorąco polecam 😊',
	},
	{
		avatar: 'J',
		avatar_color: '#f59e0b',
		person: 'Jagoda Skibicka',
		rate: 5,
		date: 'Marzec, 2023',
		description: 'Super współpraca, odpowiednio dobrany plan treningowy, wszystkim polecam 🫶🏻',
	},
];
